import { useTranslation } from 'react-i18next';

export function Footer() {
    const { t } = useTranslation('footer', 'common');
    
    return (
        <>
            <div className="footer">
                <div className="copyright">
                    <p>
                        {t('copyright')} <a href="" target="_blank">{t('company')}</a> {t('year')}
                    </p>
                </div>
            </div>
        </>
    );
}